/**
 * Copy text to the clipboard with a robust fallback.
 * Tries the async Clipboard API first, then a hidden-textarea execCommand copy.
 * Resolves on success, rejects only when both paths fail. Never throws
 * synchronously and never uses blocking browser dialogs.
 */
export function copyToClipboard(text: string): Promise<void> {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text).catch(() => execCommandCopy(text));
  }
  return execCommandCopy(text);
}

function execCommandCopy(text: string): Promise<void> {
  return new Promise((resolve, reject) => {
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      ok ? resolve() : reject(new Error("copy failed"));
    } catch (e) {
      reject(e instanceof Error ? e : new Error("copy failed"));
    }
  });
}
